import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { billingApi } from '../../lib/api'
import { PageLoading } from '../../components/LoadingSpinner'
import { useAuth } from '../../lib/auth'

const PLAN_LABELS = { GRATUITO: 'Gratuito', 'BÁSICO': 'Básico', PROFISSIONAL: 'Profissional' }

export function AdminDashboard() {
  const { user } = useAuth()
  const { data: sub, isLoading } = useQuery({
    queryKey: ['billing', 'subscription'],
    queryFn: billingApi.subscription,
  })

  if (isLoading) return <PageLoading />

  return (
    <div>
      <h1 style={{ fontSize: 'var(--font-size-2xl)', fontWeight: 700, marginBottom: 'var(--space-8)' }}>
        Painel do Administrador
      </h1>

      {/* Cards de resumo */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 'var(--space-4)',
          marginBottom: 'var(--space-8)',
        }}
      >
        <StatCard
          title="Plano atual"
          value={PLAN_LABELS[sub?.plan ?? 'GRATUITO'] ?? sub?.plan ?? '—'}
          sub={sub?.status === 'ATIVA' ? 'Assinatura ativa' : sub?.status ?? 'Trial'}
          to="/admin/billing"
          color="var(--color-primary)"
        />
        <StatCard
          title="Usuários"
          value="—"
          sub="Ver lista de usuários"
          to="/admin/usuarios"
          color="var(--color-success)"
        />
        <StatCard
          title="Espelho de Ponto"
          value="—"
          sub="Acesso ao espelho"
          to="/rh/espelho"
          color="var(--color-warning)"
        />
      </div>

      {/* Ações rápidas */}
      <div className="card">
        <h2 style={{ fontSize: 'var(--font-size-lg)', fontWeight: 600, marginBottom: 'var(--space-4)' }}>
          Ações rápidas
        </h2>
        <div style={{ display: 'flex', gap: 'var(--space-3)', flexWrap: 'wrap' }}>
          <Link to="/admin/usuarios" className="btn btn-ghost">Gerenciar usuários</Link>
          <Link to="/admin/billing" className="btn btn-ghost">Plano & Billing</Link>
          <Link to="/rh/espelho" className="btn btn-ghost">Ver espelho de ponto</Link>
        </div>
      </div>

      {user && (
        <p style={{ marginTop: 'var(--space-6)', fontSize: 'var(--font-size-xs)', color: 'var(--color-gray-400)' }}>
          Tenant: {user.tenant_id} · Papel: {user.role}
        </p>
      )}
    </div>
  )
}

function StatCard({
  title,
  value,
  sub,
  to,
  color,
}: {
  title: string
  value: string
  sub: string
  to: string
  color: string
}) {
  return (
    <Link to={to} style={{ textDecoration: 'none' }}>
      <div
        className="card"
        style={{
          borderLeft: `4px solid ${color}`,
          cursor: 'pointer',
          transition: 'box-shadow 0.15s',
        }}
        onMouseEnter={(e) => ((e.currentTarget as HTMLDivElement).style.boxShadow = 'var(--shadow-md)')}
        onMouseLeave={(e) => ((e.currentTarget as HTMLDivElement).style.boxShadow = 'var(--shadow-sm)')}
      >
        <div style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-gray-600)', marginBottom: 'var(--space-2)' }}>
          {title}
        </div>
        <div style={{ fontSize: 'var(--font-size-2xl)', fontWeight: 700, color }}>
          {value}
        </div>
        <div style={{ fontSize: 'var(--font-size-xs)', color: 'var(--color-gray-400)', marginTop: 'var(--space-1)' }}>
          {sub}
        </div>
      </div>
    </Link>
  )
}
